////
/// ============================================================================
/// COMPONENT / Global
/// ============================================================================
///
/// @group components
////

import svg4everybody from 'svg4everybody';
import fitvids from 'fitvids';

export default () => {
    svg4everybody();
    fitvids('.single__body');

    window.loadScript = function(u) {
        let t = 'script';
        let j = document.createElement(t);
        let s = document.getElementsByTagName(t)[0];

        j.src = u;
        j.async = true;
        s.parentNode.insertBefore(j, s);
    };

    // window.onCookiePolicyAccepted(function () {
    //     if (typeof fbLang !== 'undefined' && !isFrontPage) {
    //         window.fbAsyncInit = function () {
    //             FB.init({
    //                 appId: fbAppId,
    //                 status: true,
    //                 xfbml: true,
    //                 version: 'v2.3'
    //             });
    //         };
    //         window.loadScript('//connect.facebook.net/' + fbLang + '/sdk.js');
    //     }
    // });
}
